module.exports = __webpack_public_path__ + "img/users_docsign.325996f0.png";